import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import { RequireFeatureComponent, features } from '../features';
import { tenantHelpers } from '../tenantInfo';
import './nav.scss';

export class AdminNavLinks extends Component {

  showUpdates(isParent, providerId, subjectIdentifier) {
    return (isParent || providerId + '' === subjectIdentifier + '' );
  }

  updatesControl(show, updates) {
    updates = show ? updates : 0;
    return (
      <div className={`pending-updates ${updates ? 'has-pending-updates' : ''}`}>
        <span className="pending-updates-count">
          {updates}
        </span>
        {'Pending Update' + (updates === 1 ? '' : 's')}
      </div>
    );
  }

  render() {
    const { pathname } = this.props;

    var activeClass = "router-link-active";

    // these routes need to be checked because this is an index route with multiple tabs, the child routes are indistinquishable from sibling routes
    const accountRoutes = ['/', '/registered', '/unregistered'];

    return (
      <div className="admin-nav-links">
        <ul>
          <li>
            <NavLink to="/" exact activeClassName={activeClass} isActive={() => accountRoutes.includes(pathname)}>
              Participant Accounts
            </NavLink>
            <NavLink to="/settings" activeClassName={activeClass}>
              Settings
            </NavLink>
            {
              /* this link is hidden for now until program enrollment options are to be added to the portal
              <NavLink to="/programs" activeClassName={activeClass}>
                Program Access
              </NavLink>
              */
            }
            <NavLink to="/permissions" activeClassName={activeClass}>
              Participant Permissions
            </NavLink>
            <NavLink to="/dashboard-messages" activeClassName={activeClass}>
              Notifications
            </NavLink>
            <RequireFeatureComponent requiredFeatures={[features.intake]}>
              <NavLink to="/intake-forms" activeClassName={activeClass}>
                Intake Forms
              </NavLink>
            </RequireFeatureComponent>
          </li>
        </ul>
      </div>
    );
  }
}

AdminNavLinks.propTypes = {
  setKey: PropTypes.func,
  pathname: PropTypes.string,
};

export default AdminNavLinks;
